// Marktplatz-Stammdaten fuers Retourentool (Trello 18.08., P3/P5): normierter Schluessel
// (kommt vom Backend, ReturnMarketplaceHelper) -> Anzeige, Farbe und Bestell-Deeplink.
// Icons sind vorerst Text-Badges - der Kunde liefert Icon-Dateien nach, dann hier nur
// ein icon-Feld ("/img/marketplaces/....svg") ergaenzen.
const MARKETPLACES = {
  amazon: { label: "Amazon", short: "AMZ", color: "#ff9900", orderUrl: (nr) => `https://sellercentral.amazon.de/orders-v3/order/${nr}` },
  ebay: { label: "ebay", short: "EBAY", color: "#e53238", orderUrl: (nr) => `https://www.ebay.de/mesh/ord/details?orderid=${nr}` },
  kaufland: { label: "Kaufland", short: "KFL", color: "#e10915", orderUrl: (nr) => `https://sellerportal.kaufland.de/order/${nr}` },
  otto: { label: "OTTO", short: "OTTO", color: "#d4021d", orderUrl: (nr) => `https://portal.otto.market/orders#/details/${nr}` },
  // Manomano/CDiscount haben keine Order-URL (on-page-Suche) - bewusst nur die feste Uebersicht
  manomano: { label: "ManoMano", short: "MM", color: "#12655b", orderUrl: () => "https://toolbox.manomano.com/orders" },
  cdiscount: { label: "CDiscount", short: "CD", color: "#2c3e91", orderUrl: () => "https://seller.octopia.com/order/all" },
  temu: { label: "TEMU", short: "TEMU", color: "#fb7701", orderUrl: () => "https://seller-eu.temu.com/orders.html" },
  tiktok: { label: "TikTok", short: "TT", color: "#161823", orderUrl: (nr) => `https://seller-de.tiktok.com/order/detail?order_no=${nr}` },
  shopify_cs: { label: "CS-Trading Store", short: "CS", color: "#7f915a", orderUrl: () => "https://admin.shopify.com/store/vzg5s3-aj/orders" },
  shopify_bt: { label: "BBQ-Toro Store", short: "BT", color: "#7f915a", orderUrl: () => "https://admin.shopify.com/store/1yexkv-a5/orders" },
  shopify_cf: { label: "CampFeuer Store", short: "CF", color: "#7f915a", orderUrl: () => "https://admin.shopify.com/store/7jgn8k-iv/orders" },
  shopify_hw: { label: "Highwerk Store", short: "HW", color: "#7f915a", orderUrl: () => "https://admin.shopify.com/store/zptdjc-r6/orders" },
  shopify_mz: { label: "mahlzeit Store", short: "MZ", color: "#7f915a", orderUrl: () => "https://admin.shopify.com/store/rstafq-sa/orders" },
  shopify: { label: "Shopify", short: "SHOP", color: "#7f915a", orderUrl: () => null },
  other: { label: "", short: "?", color: "#9e9e9e", orderUrl: () => null },
};

export function marketplaceInfo(key) {
  return (key && MARKETPLACES[key]) || null;
}

// Deeplink zur Bestellung; null wenn es keinen gibt (dann nur Text anzeigen)
export function marketplaceOrderUrl(key, orderNumber) {
  const mp = marketplaceInfo(key);
  if (!mp) return null;
  return mp.orderUrl(orderNumber ? encodeURIComponent(String(orderNumber).trim()) : "");
}

// Die Zweitnummer (Shopify-Bestellnr. bei TEMU/TikTok) verlinkt in den zugehoerigen Store
export function shopifyStoreUrlForOrder(orderNumber) {
  const prefix = String(orderNumber || "")
    .split("-")[0]
    .toUpperCase();
  const key = { CS: "shopify_cs", BT: "shopify_bt", CF: "shopify_cf", HW: "shopify_hw", MZ: "shopify_mz" }[prefix];
  return key ? MARKETPLACES[key].orderUrl() : null;
}

// Paketdienstleister der Ruecksendung (P18) - Platzhalter-Badges, Icons liefert der Kunde nach
const CARRIERS = {
  dhl: { label: "DHL", short: "DHL", color: "#ffcc00", text: "#d40511" },
  dpd: { label: "DPD", short: "DPD", color: "#dc0032", text: "#fff" },
  gls: { label: "GLS", short: "GLS", color: "#061ab1", text: "#ffd100" },
  hermes: { label: "Hermes", short: "HER", color: "#0091cd", text: "#fff" },
  la_poste: { label: "La Poste", short: "LP", color: "#f5c400", text: "#003366" },
  colissimo: { label: "Colissimo", short: "COL", color: "#e63323", text: "#fff" },
  at_post: { label: "Österreichische Post", short: "AT", color: "#ffd500", text: "#000" },
  unknown: { label: "unklar", short: "?", color: "#9e9e9e", text: "#fff" },
};

export function carrierInfo(key) {
  return (key && CARRIERS[key]) || null;
}

export function carrierOptions() {
  return Object.keys(CARRIERS).map((k) => ({ id: k, name: CARRIERS[k].label }));
}

// Auswahl fuer den Filter-Drawer; "other" hat bewusst kein Label (Badge zeigt nur "?")
export function marketplaceOptions() {
  return Object.keys(MARKETPLACES).map((k) => ({ id: k, name: MARKETPLACES[k].label || "Sonstige" }));
}
